"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Day = void 0;
var Day;
(function (Day) {
    Day["Monday"] = "monday";
    Day["Tuesday"] = "tuesday";
    Day["Wednesday"] = "wednesday";
    Day["Thursday"] = "thursday";
    Day["Friday"] = "friday";
    Day["Saturday"] = "saturday";
    Day["Sunday"] = "sunday";
})(Day || (exports.Day = Day = {}));
